import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosDotnet from '../services/axiosDotnet';
import { showSuccess, showError } from '../services/reactToastify';
import Loader from "../Components/Loader";

export default function UpdateProject() {
    const id = useParams().pId;
    const wId = useParams().cwId;
    const navigate = useNavigate();

    const [project, setProject] = useState({ title: '', description: '' });
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchProject = async () => {
            try {

                const res = await axiosDotnet.get(`/api/projects/project/${id}`);
                setProject({
                    title: res.data.title,
                    description: res.data.description || ''
                });
            } catch (err) {
                // showError("Failed to load project");
            } finally {
                setLoading(false);
            }
        };

        fetchProject();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axiosDotnet.put(`/api/projects/${id}`, {
                title: project.title,
                description: project.description
            });

            showSuccess("Project updated successfully!");
            navigate(`/workspace/${wId}`);
        } catch (err) {
            showError(err?.response?.data?.message || "Failed to update project! You must be admin of project workspace to do so..");
        }
    };

    if (loading) return <Loader text="Loading Project Data..." />;

    return (
        <div className="min-h-screen bg-zinc-950 text-white p-8">
            <div className="max-w-2xl mx-auto">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-6 cursor-pointer text-violet-400 hover:text-violet-300 flex items-center gap-2"
                >
                    ← Back
                </button>

                <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-10">
                    <h1 className="text-3xl font-bold mb-8">Update Project</h1>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm text-zinc-400 mb-2">Project Title</label>
                            <input
                                type="text"
                                value={project.title}
                                onChange={(e) => setProject({ ...project, title: e.target.value })}
                                className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm text-zinc-400 mb-2">Description</label>
                            <textarea
                                value={project.description}
                                onChange={(e) => setProject({ ...project, description: e.target.value })}
                                rows={6}
                                className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none resize-y"
                            />
                        </div>

                        <div className="flex gap-4 pt-4">
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                className="flex-1 py-4 border border-zinc-700 rounded-2xl hover:bg-zinc-800"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="cursor-pointer flex-1 py-4 bg-violet-600 hover:bg-violet-500 rounded-2xl font-semibold"
                            >
                                Update Project
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}